import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-page-loading',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './page-loading.component.html',
  styleUrls: ['./page-loading.component.scss']
})
export class PageLoadingComponent {
  @Input() eyebrow = 'Loading';
  @Input() title = 'Preparing your page';
  @Input() message = 'Fetching the latest data and arranging everything in place.';
  @Input() variant: 'list' | 'detail' | 'form' = 'detail';
}
